import React from 'react';
import { PencilSquareIcon, DocumentArrowDownIcon } from '@heroicons/react/24/solid';

const CustomerActionsMenu = ({ customer, onEdit, onDownload, isMobile }) => {
  if (isMobile) {
    return (
      <div className="flex flex-col gap-1 items-end ml-2">
        <button onClick={onEdit} className="text-blue-600 flex items-center text-sm">
          <PencilSquareIcon className="w-4 h-4 mr-1" />
          Edit
        </button>
        <button onClick={onDownload} className="text-green-600 flex items-center text-sm">
          <DocumentArrowDownIcon className="w-4 h-4 mr-1" />
          Contract
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onEdit}
        className="p-1 rounded-full hover:bg-gray-100"
        title="Edit"
      >
        <PencilSquareIcon className="h-5 w-5 text-blue-600" />
      </button>
      {
        (customer.sla_contract && (
          <button
            onClick={onDownload}
            className="p-1 rounded-full hover:bg-gray-100"
            title="Download Contract"
          >
            <DocumentArrowDownIcon className="h-5 w-5 text-green-600" />
          </button>
        )
      )}
    </div>
  );
};

export default CustomerActionsMenu;
